import "bootstrap/dist/css/bootstrap.min.css";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import './components/webcomponents/polyfills.be4631ccdcd07ea5';
import './components/webcomponents/main.7c1ac1f263e77ac2';
import './components/webcomponents/runtime.074a8dee3fdd6703';
import './components/webcomponents/styles.2b5a1327edc37180.css';

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
